import Axios from "axios";
import {
  SET_EMPLOYEE_JOB_CARD_REPORT,
  UNSET_EMPLOYEE_JOB_CARD_REPORT,
} from "@/store/mutation-types";
import {
  getEmployeeJobCard,
} from "@/store/api";

const state = {
  employeeJobCardReport: [],
};

const getters = {
  getEmployeeJobCardReport(state) {
    return state.employeeJobCardReport;
  },
};

const mutations = {
  [SET_EMPLOYEE_JOB_CARD_REPORT](state, data) {
    state.employeeJobCardReport = data;
  },
  [UNSET_EMPLOYEE_JOB_CARD_REPORT](state) {
    state.employeeJobCardReport = [];
  },
};

const actions = {
  getEmployeeJobCard({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getEmployeeJobCard}`, { params: data })
        .then((response) => {
          commit(SET_EMPLOYEE_JOB_CARD_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_EMPLOYEE_JOB_CARD_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
